const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Transaction Type',
        dataIndex: 'transactionType',
        sorter: (a, b) => a?.transactionType - b?.transactionType,
    },
    {
        title: 'Payment From',
        dataIndex: 'paymentFrom',
        sorter: (a, b) => a?.paymentFrom?.localeCompare(b?.paymentFrom),
    },
    {
        title: 'Payment To',
        dataIndex: 'paymentTo',
        sorter: (a, b) => a?.paymentTo?.localeCompare(b?.paymentTo),
        render: defaultRender
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: (a, b) => a?.amount - b?.amount,
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        sorter: (a, b) => a?.currency?.localeCompare(b?.currency),
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];

export default columns;